export default "__VITE_ASSET__CtGMICTb__"